import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Main from '@/modules/Main/Main.vue'
import AboutView from '@/views/About/AboutView.vue'


const routes: Array<RouteRecordRaw> = [
  //Main===========================================================
  {
    path: '/',
    name: 'Main',
    component: Main,
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/HomeView/HomeView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/cek_kalori',
    name: 'cek_kalori',
    component: () => import('@/views/CekKaloriView/CekKaloriView.vue'),
  },
  {
    path: '/info_dm',
    name: 'info_dm',
    component: () => import('@/views/InfoDMView/InfoDMView.vue'),
  },
  {
    path: '/pengaturan_makanan',
    name: 'pengaturan_makanan',
    component: () => import('@/views/PengaturanMakanView/PengaturanMakanView.vue'),
  },
  {
    path: '/pengaturan_makanan_list',
    name: 'pengaturan_makanan_list',
    component: () => import('@/views/PengaturanMakanListView/PengaturanMakanListView.vue'),
  },
  {
    path: '/pengaturan_makanan_konten',
    name: 'pengaturan_makanan_konten',
    component: () => import('@/views/PengaturanMakanKontenView/PengaturanMakanKontenView.vue'),
  },
  {
    path: '/konsultasi_gizi',
    name: 'konsultasi_gizi',
    component: () => import('@/views/KonsultasiGiziView/KonsultasiGiziView.vue'),
  },
  
  //Main===========================================================
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),//
  routes,
  linkActiveClass: 'font-bold',
  linkExactActiveClass: ''
})

export default router
